import { Col, Flex, Form, InputNumber, Row } from "antd";
import React, { useLayoutEffect, useState } from "react";
import { UI_ITOModuleSuccess } from "../../../../../UI_ITO/UI_ITOModuleSuccess/UI_ITOModuleSuccess";
import { useForm } from "antd/es/form/Form";
import {
  formatter,
  parser,
} from "../../../../../utils/utilities/InputSumFunctions";
import { ruleSummMinMax } from "../../../../../constants/rules/RulesConstantsForms";
import { useGetApplicationDataToBankQuery } from "../../../../../store/api/applicationBankApi/applicationBank.api";
import { useParams } from "react-router-dom";
import classes from './ApplicationCommission.module.css';
import { commisionFields } from "../../../../../constants/commisionFields";

export const ApplicationCommission = () => {
  const { applicationBankId, applicationId } = useParams();
  const { data: applicationBank } = useGetApplicationDataToBankQuery({
    applicationBankId: Number(applicationBankId),
    applicationId: Number(applicationId),
  });

  const [status, setStatus] = useState<"active" | "inactive">("inactive");
  const [form] = useForm();
  const initialValues = {
    base_commission: Number(applicationBank?.base_commission),
    bank_rate: Number(applicationBank?.bank_rate),
    overstatement: Number(applicationBank?.overstatement),
    final_commission: Number(applicationBank?.final_commission),
  };

  // Подставляем initialValues в форму, когда появляются результаты выполнения запроса
  useLayoutEffect(() => {
    if (applicationBank) {
      form.resetFields();
    }
  }, [applicationBank, form]);

  return (
    <>
      <p className={classes.commisionTitle}>Коммисия</p>
      <Form
        layout="vertical"
        form={form}
        onChange={() => setStatus("active")}
        initialValues={initialValues}
      >
        <div className={classes.commisionsItems}>
           {commisionFields.map((field, index) => {
            if (field) {
              return (
                <div className={classes.commisionItem} key={index}>
                  <Form.Item
                    label={field.label}
                    name={field.name}
                    rules={
                      field.unitOfMeasurement === "rubles"
                        ? [ruleSummMinMax]
                        : undefined
                    }
                  >
                    <InputNumber
                      disabled
                      size="large"
                      min={field.unitOfMeasurement === "percent" ? "0" : ""}
                      suffix={field.suffix}
                      controls={false}
                      style={{ width: "100%" }}
                      {...(field.unitOfMeasurement === "rubles"
                        ? {
                            formatter,
                            parser,
                          }
                        : {})}
                    />
                  </Form.Item>
                </div>
              );
            }
          })}
        </div>
        <Flex justify="flex-end" align="center" gap={8}>
          <UI_ITOModuleSuccess
            title="Данные были изменены, необходимо сохранение"
            isSuccess={status === "active"}
          />
        </Flex>
      </Form>
    </>
  );
};
